import { Box, useToken } from '@chakra-ui/react';

export function ProductActiveTraitMeter({ value }: { value: number }) {
  const [lightGray, darkGray] = useToken('colors', [
    'blackAlpha.250',
    'gray.600',
  ]);

  return (
    <Box position="relative" maxWidth="72px" height="8px">
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        role="img"
        aria-label={`Average value ${value} out of 5`}
      >
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          rx="4"
          ry="4"
          fill={lightGray}
          aria-hidden
        />
        <rect
          x="0"
          y="0"
          width={`calc((100% - 8px) / 4 * ${value - 1} + 8px)`}
          height="100%"
          rx="4"
          ry="4"
          fill={darkGray}
          aria-hidden
        />
        <circle key="dot-0" cx="4" cy="50%" r="2" fill="white" aria-hidden />
        {[1, 2, 3].map((i) => (
          <circle
            key={`dot-${i}`}
            cx={`calc((100% - 8px) / 4 * ${i} + 4px)`}
            cy="50%"
            r="2"
            fill="white"
            aria-hidden
          />
        ))}
        <circle
          key="dot-4"
          cx="calc(100% - 4px)"
          cy="50%"
          r="2"
          fill="white"
          aria-hidden
        />
      </svg>
    </Box>
  );
}
